<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">담당회원확인</span>
            <span class="txt">직원 본인이 담당강사로 되어있는 회원정보, 수업정보를 확인합니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['기간선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['센터명', ...chainCenterType]"
                    :select-value="['', ...chainCenterTypeValue]"
                    :selected-value="centerName"
                    @update:set="(val) => (centerName = val)"
                ></select-form>
                <select-form
                    :select-data="['이용권 구분', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복']"
                    :select-value="['', 'P', 'O', 'D', 'G', 'C', 'T', 'S']"
                    :selected-value="ticketType"
                    @update:set="(val) => (ticketType = val)"
                ></select-form>
                <select-form
                    :select-data="['카테고리명', ...categoryList]"
                    :select-value="['', ...categoryValList]"
                    :selected-value="category"
                    @update:set="(val) => (category = val)"
                ></select-form>
                <select-form
                    :select-data="['결제수단', '카드', '현금', '계좌이체', '마일리지', '키오스크', '기타']"
                    :select-value="['', 'C', 'L', 'B', 'M', 'K', 'E']"
                    :selected-value="payType"
                    @update:set="(val) => (payType = val)"
                ></select-form>
                <select-form
                    :select-data="['등록구분', '신규', '재등록']"
                    :select-value="['', 'N', 'R']"
                    :selected-value="saleStaffContractType"
                    @update:set="(val) => (saleStaffContractType = val)"
                ></select-form>
                <!-- <select-form :select-data='["강사명", ...staffname]'></select-form> -->
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <p class="sub-title">회원목록</p>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="execlDownload">엑셀 다운로드</button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 40px" />
                    <col style="width: 110px" />
                    <col style="width: 160px" />
                    <col style="width: 280px" />
                    <col style="width: 160px" />
                    <col style="width: 110px" v-if="isAllowed('SA', 6)" />
                    <col style="width: 140px" v-if="isAllowed('SA', 6)" />
                    <col style="width: 120px" />
                    <col style="width: 90px" />
                    <col style="width: 90px" />
                    <col style="width: 135px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input
                                    id="check-all"
                                    v-model="selectedAll"
                                    name="check-all"
                                    type="checkbox"
                                    @click="checkedAll"
                                />
                                <label for="check-all"></label>
                            </div>
                        </th>
                        <th>회원명</th>
                        <th>유효기간</th>
                        <th>이용권명</th>
                        <th>이용권 현황</th>
                        <th v-if="isAllowed('SA', 6)">구매가</th>
                        <th v-if="isAllowed('SA', 6)">결제정보</th>
                        <th>등록구분</th>
                        <th>담당강사</th>
                        <th>등록일자</th>
                        <th>센터명</th>
                    </tr>
                </thead>
                <!-- <tbody> -->
                <!-- <tr>
                        <td>
                            <div class="com-check">
                                <input type="checkbox" name="check-1" id="check-1-1">
                                <label for="check-1-1"></label>
                            </div>
                        </td>
                        <td>
                            <span class="info-line">
                                <span class="blue">홍길동</span>
                                <span>010-0000-0000</span>
                            </span>
                        </td>
                        <td>
                            <span class="info-line">
                                <span>2020-01-01 ~ 2020-01-31</span>
                                <span class="under">154일 남음</span>
                            </span>
                        </td>
                        <td>
                            <span class="ico type-1">[개인]</span>
                            <span class="ico type-2">[그룹]</span>
                            <span class="ico type-3">[패키지]</span>
                            <span class="ico type-4">[회원권]</span>
                            <span class="ico type-5">[듀엣]</span>
                            <span class="ico type-6">[OT]</span>
                            필라테스 10회 PL + 개인레스 PL 10회
                        </td>
                        <td>
                            <span class="info-line">
                                <span>
                                    <span class="red">8</span>/10 회 (출석 <span class="red">6</span> / 결석 <span class="red">2</span>)
                                </span>
                                <span class="center">
                                    <a href="#" class="com-btn-small deep-black">스케줄 &gt;</a>
                                </span>
                            </span>
                        </td>
                        <td>500,000 원</td>
                        <td>[카드] 500,000 원</td>
                        <td>신규 1회</td>
                        <td>김윤경</td>
                        <td>2019.08.20</td>
                        <td>핏투데이케어 - 신촌점</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-check">
                                <input type="checkbox" name="check-1" id="check-1-2">
                                <label for="check-1-2"></label>
                            </div>
                        </td>
                        <td>
                            <span class="info-line">
                                <span class="blue">홍길동</span>
                                <span>010-0000-0000</span>
                            </span>
                        </td>
                        <td>
                            <span class="info-line">
                                <span>2020-01-01 ~ 2020-01-31</span>
                                <span class="under red">만료 4일 전</span>
                            </span>
                        </td>
                        <td>
                            <span class="ico type-1">[개인]</span>
                            필라테스 10회 PL + 개인레스 PL 10회
                        </td>
                        <td>
                            <span class="info-line">
                                <span>
                                    <a href="#" class="red">상세보기 &gt;</a>
                                </span>
                                <span class="center">
                                    <a href="#" class="com-btn-small deep-black">스케줄 &gt;</a>
                                </span>
                            </span>
                        </td>
                        <td>500,000 원</td>
                        <td>
                            [계좌] 300,000 원<br>
                            <span class="red">[미수금] 200,000 원</span>
                        </td>
                        <td>신규 1회</td>
                        <td></td>
                        <td>2019.08.20</td>
                        <td>핏투데이케어 - 신촌점</td>
                    </tr> -->
                <tbody>
                    <tr v-for="(member, i) in memberList" :key="member.cc_center_contract_id">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="member.cc_center_contract_id"
                                    v-model="selected"
                                    :value="i"
                                    name="check-1"
                                    type="checkbox"
                                />
                                <label :for="member.cc_center_contract_id"></label>
                            </div>
                        </td>
                        <td>
                            <span class="info-line">
                                <span class="blue">{{ member.cc_customer_name }}</span>
                                <span>{{ member.cc_customer_phone | customerPhoneFilter }}</span>
                            </span>
                        </td>
                        <td>
                            <span class="info-line">
                                <span>
                                    {{ member.cc_exp_start_dt | timestampFilter }} ~
                                    {{ member.cc_exp_end_dt | timestampFilter }}
                                </span>
                                <span v-if="member.cc_diff_day > 0 && member.cc_diff_day <= 100" class="under red">
                                    만료 {{ member.cc_diff_day }}일 전
                                </span>
                                <span v-if="member.cc_diff_day > 100" class="under black">
                                    {{ member.cc_diff_day }}일 남음
                                </span>
                                <span v-if="member.cc_diff_day === 0" class="under red">당일만료</span>
                                <span v-if="member.cc_diff_day < 0" class="under red">기간만료</span>
                            </span>
                        </td>
                        <td>
                            <span v-if="member.cp_ticket_type_cd === 'P'" class="ico type-1">[개인]</span>
                            <span v-if="member.cp_ticket_type_cd === 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="member.cp_ticket_type_cd === 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="member.cp_ticket_type_cd === 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="member.cp_ticket_type_cd === 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="member.cp_ticket_type_cd === 'O'" class="ico type-6">[OT]</span>
                            <span v-if="member.cp_ticket_type_cd === 'S'" class="ico type-8">[운동복]</span>
                            <router-link
                                :to="{
                                    path: `/madmin/member/account/${centerId}`,
                                    query: {
                                        customerId: member.cc_center_cust_id,
                                        contractId: member.cc_center_contract_id,
                                    },
                                }"
                            >
                                {{ member.cc_lesson_name }}
                            </router-link>
                        </td>
                        <!--                        <td>-->
                        <!--                            <span class="info-line">-->
                        <!--                                <span>-->
                        <!--                                    <span class="red">{{member.cc_less_join_cnt + member.cc_less_absn_cnt}}</span>/{{member.cc_less_cnt}} 회 (출석 <span class="red">{{member.cc_less_join_cnt != null ? member.cc_less_join_cnt : 0}}</span> / 결석 <span class="red">{{member.cc_less_absn_cnt != null ? member.cc_less_absn_cnt : 0}}</span>)-->
                        <!--                                </span>-->
                        <!--                                <span class="center">-->
                        <!--                                    <router-link :to="{ path: `/madmin/course/care/reserve`, query: { customerId : member.cc_center_cust_id, contractId: member.cc_center_contract_id, centerProductId: member.cp_center_prod_id } }" class="com-btn-small deep-black">스케줄 &gt;</router-link>-->
                        <!--                                </span>-->
                        <!--                            </span>-->
                        <!--                        </td>-->
                        <td>
                            <span class="info-line">
                                <span v-if="member.cc_prod_type_cd === 'P'">
                                    <span class="red">상세보기 &gt;</span>
                                </span>
                                <span v-if="member.ccp_less_cnt_type_cd === 'U'">
                                    <!--무제한인 경우-->
                                    무제한
                                </span>
                                <span v-else-if="member.ccp_less_cnt_type_cd === 'W'">
                                    <!--횟수가 존재-->
                                    주{{ member.cc_less_cnt }} 회 (출석
                                    <span class="red">
                                        {{ member.cc_less_join_cnt != null ? member.cc_less_join_cnt : 0 }}
                                    </span>
                                    / 결석
                                    <span class="red">
                                        {{ member.cc_less_absn_cnt != null ? member.cc_less_absn_cnt : 0 }}
                                    </span>
                                    )
                                </span>
                                <span
                                    v-else-if="member.cp_ticket_type_cd === 'T' && member.ccp_less_cnt_type_cd !== 'U'"
                                >
                                    <!--회원권이지만 무제한이 아닌경우-->
                                    <span class="red">{{ member.cc_less_join_cnt + member.cc_less_absn_cnt }}</span>
                                    / {{ member.cc_less_cnt }} 회
                                </span>
                                <span v-else>
                                    <!--그외-->
                                    <span class="red">{{ member.cc_less_join_cnt + member.cc_less_absn_cnt }}</span>
                                    /{{ member.cc_less_cnt }} 회 (출석
                                    <span class="red">
                                        {{ member.cc_less_join_cnt != null ? member.cc_less_join_cnt : 0 }}
                                    </span>
                                    / 결석
                                    <span class="red">
                                        {{ member.cc_less_absn_cnt != null ? member.cc_less_absn_cnt : 0 }}
                                    </span>
                                    )
                                </span>
                                <span v-if="member.cp_ticket_type_cd !== 'T'" class="center">
                                    <router-link
                                        :to="{
                                            path: `/madmin/course/care/reserve`,
                                            query: {
                                                customerId: member.cc_center_cust_id,
                                                contractId: member.cc_center_contract_id,
                                                centerProductId: member.cp_center_prod_id,
                                            },
                                        }"
                                        class="com-btn-small deep-black"
                                    >
                                        스케줄 &gt;
                                    </router-link>
                                </span>
                            </span>
                        </td>
                        <td v-if="isAllowed('SA', 6)">{{ member.cc_total_buy_price | numberFormatFilter }} 원</td>
                        <td v-if="isAllowed('SA', 6)">
                            <span v-if="member.cc_ret_yn" class="info-line">
                                <span class="red">환불완료</span>
                            </span>
                            <span v-else class="info-line">
                                <span>{{ convertBill(member.cc_bill_info) }}</span>
                                <!-- <span class="red">[미수금] 200,000 원</span> -->
                                <span v-if="member.cc_total_debt_price != 0" class="red">
                                    [미수금] {{ member.cc_total_debt_price | numberFormatFilter }}원
                                </span>
                            </span>
                        </td>
                        <td>{{ convertContractType(member.cc_contract_type_cd) }}</td>
                        <td>{{ member.cc_staff_name }}</td>
                        <td>{{ member.cc_cre_dt | timestampFilter }}</td>
                        <td>{{ member.cc_center_nm }}</td>
                    </tr>
                    <tr v-if="memberList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn deep-blue">메시지 발송</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import XLSX from 'xlsx';
import { numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { Utils } from '@/assets/js/utils';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'MypageList',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
    },
    watch: {
        ticket(newValue) {
            this.ticket = newValue;
            this.onSearchList();
        },
        ticketName() {
            // 티켓이름 바인드 테스트
        },
        period(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onSearchList();
        },
        startDate(newValue) {
            this.startDate = newValue;
        },
        endDate(newValue) {
            this.endDate = newValue;
        },
        ticketType(newValue) {
            this.ticketType = newValue;
            this.onSearchList();
        },
        payType(newValue) {
            this.payType = newValue;
            this.onSearchList();
        },
        saleStaffContractType(newValue) {
            this.saleStaffContractType = newValue;
            this.onSearchList();
        },
        category(newValue) {
            this.category = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            ticket: '',
            centerStaffId: this.$store.state.auth.user.uid,
            checked: [],
            searchStr: '',
            centerName: '',
            ticketNameList: [],
            ticketNameValueList: [],
            period: '',
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            memberList: {},
            pagingInfo: { ...pagingInfo },
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            selectedAll: false,
            selected: [],
            staffname: [],

            ticketType: '', // 이용권 유효코드
            payType: '', // 결제유형
            saleStaffContractType: '', // 계약유형

            categoryList: [],
            categoryValList: [],
            category: '',

            chainCenterType: [],
            chainCenterTypeValue: [],

            hasMessageEvent: false, // 권한에 따른 메세지 발송 버튼
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            await this.fetchTicketList();
            await this.onSearchList(); // 목록 리스트
            await this.onStaffInfo(); // 스태프 리스트
            await this.onCategoryList(); // 카테고리 리스트
            await this.fetchChainCenter(); // 센터 체인 조회
        },

        // 담당 회원 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                console.log('리스트', data);
                this.setPageParams(data, 'center');
                this.memberList = data.items;
                this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 담당 회원 조회 API
        getCenterList() {
            // 스웨거 검색: 담당회원확인 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/mypage/lesson/manage-customer`, {
                params: {
                    searchStr: this.searchStr,
                    productType: this.ticket,
                    centerStaffId: this.centerStaffId, // 담당강사
                    ticketType: this.ticketType,
                    createStartDate: moment(this.startDate).format('YYYYMMDD'),
                    createEndDate: moment(this.endDate).format('YYYYMMDD'),
                    centerProductCategoryTemplateId: this.category,
                    payType: this.payType,
                    saleStaffContractType: this.saleStaffContractType,
                    ...this.pagingInfo,
                },
            });
        },

        // 담당 회원 조회 호출
        async onStaffInfo() {
            try {
                const { data } = await this.getStaffInfo();
                this.staffname = 'naver';
                console.log(this.staffInfo);
            } catch (error) {
                console.log(error);
                console.log('스태프정보를 가져올수없습니다.');
            }
        },

        // 스태프 정보 가져오기
        getStaffInfo() {
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}`);
        },

        // 이벤트 발생시 키워드 길이 체크
        onEventSearch(e) {
            if (this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },

        // 이용권 코드
        convertTiketTypeFormat(ticket) {
            if (ticket == 'P') {
                return '[패키지]';
            } else if (ticket == 'T') {
                return '[이용권]';
            } else if (ticket == 'L') {
                return '[락커]';
            } else if (ticket == 'S') {
                return '[부가상품]';
            }
        },

        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            return startDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onSearchList();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            this.ticketType = '';
            this.centerType = '';
            this.saleStaffContractType = '';
            (this.payType = ''), (this.searchStr = '');
            this.onSearchList();
            EventBus.$emit('event:init', 'init');
        },
        changeLimit() {
            // 메세지 발송
        },
        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.memberList) {
                    this.selected.push(i);
                }
            }
        },

        // 이용권 목록 조회
        async fetchTicketList() {
            try {
                const { data } = await this.getCenterList();
                data.items.forEach((g) => {
                    this.ticketNameList.push(g.cc_lesson_name);
                    console.log(this.ticketNameList);
                    //
                });
            } catch (error) {
                console.log('티켓값을 가져오는데 오류가 발생했습니다.');
                console.log(error);
            }
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 계약유형
        convertContractType(val) {
            if (val == 'N') {
                return '신규';
            } else if (val == 'R') {
                return '재등록';
            } else if (val == 'C') {
                return '환불';
            }
        },
        // 결제정보 컨버팅
        convertBill(bill) {
            if (bill === null || bill === '' || bill === undefined) {
                return bill;
            }
            const a = bill.split('|');
            const data = [];
            for (const e of a) {
                const b = e.split('_');
                data.push({ type: b[0], amount: parseInt(b[1]) });
            }

            let sum = {};
            let type = '';
            for (const c of data) {
                if (sum.type == undefined) {
                    sum = c;
                } else {
                    sum.amount += c.amount;
                }
            }

            if (sum.type == 'C') {
                type = '[카드]';
            } else if (sum.type == 'L') {
                type = '[현금]';
            } else if (sum.type == 'B') {
                type = '[계좌이체]';
            } else if (sum.type == 'M') {
                type = '[마일리지]';
            } else if (sum.type == 'K') {
                type = '[키오스크]';
            } else if (sum.type == 'E') {
                type = '[기타]';
            }

            const result = `${type} ${Utils.getNumberFormat(sum.amount)}원`;
            return result;
        },
        // 카테고리명 조회
        async onCategoryList() {
            try {
                const { data } = await this.getCategoryList();
                console.log(data);
                data.forEach((g) => {
                    this.categoryList.push(g.name);
                    this.categoryValList.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('카테고리 값을 가져오는데 실패했습니다.');
            }
        },
        getCategoryList() {
            return api.get(`/admin/api/center/${this.centerId}/product/category/template`);
        },
        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            return api.get(`/admin/api/center/${this.centerId}/chain`);
        },

        // 회원목록 엑셀 다운로드 기능구현
        async execlDownload() {
            const { data } = await this.getMembersListExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.items.forEach((member) => {
                const temp = {};
                temp['회원명'] = member.cc_customer_name;
                temp['유효기간'] = `${timestampToDate(member.cc_exp_start_dt)}~${timestampToDate(
                    member.cc_exp_end_dt
                )}`;
                temp['이용권명'] = `${this.ticketTypeStringExcel(member.cp_ticket_type_cd)}${member.cc_lesson_name}`;
                temp['이용권현황'] = this.ticketCntStringExcel(
                    member.cc_less_join_cnt,
                    member.cc_less_absn_cnt,
                    member.cc_less_cnt
                );
                temp['구매가'] = `${numberFormat(member.cc_total_buy_price)}원`;
                temp['결제정보'] = this.paymentInfoStringExcel(member.cc_bill_info, member.cc_total_debt_price);
                temp['등록구분'] = this.convertContractType(member.cc_contract_type_cd);
                temp['담당강사'] = member.cc_staff_name;
                temp['등록일자'] = timestampToDate(member.cc_cre_dt);
                temp['센터명'] = member.cc_center_nm;

                excelDownloadArray.push(temp);
            });

            /* [Key:value, ...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 24 },
                { wch: 50 },
                { wch: 30 },
                { wch: 12 },
                { wch: 35 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '회원목록');
            XLSX.writeFile(wb, '회원목록.xlsx');
        },

        // 엑셀 다운로드를 위한 회원목록
        getMembersListExcel() {
            return api.get(`/admin/api/center/${this.centerId}/mypage/lesson/manage-customer`, {
                params: {
                    page: 1,
                    limit: 10000,
                    centerStaffId: this.centerStaffId,
                    expireStartDate: moment(this.startDate).format('YYYYMMDD'),
                    expireEndDate: moment(this.endDate).format('YYYYMMDD'),
                    ticketType: this.ticketType,
                    centerProductCategoryTemplateId: this.category,
                    payType: this.payType,
                    saleStaffContractType: this.saleStaffContractType,
                    searchStr: this.searchStr,
                },
            });
        },

        // 엑셀에서 이용권 구분을 위한 필터
        ticketTypeStringExcel(cp_ticket_type_cd) {
            if (cp_ticket_type_cd === 'P') return '[개인]';
            else if (cp_ticket_type_cd === 'G') return '[그룹]';
            else if (cp_ticket_type_cd === 'C') return '[쿠폰]';
            else if (cp_ticket_type_cd === 'T') return '[회원권]';
            else if (cp_ticket_type_cd === 'D') return '[듀엣]';
            else if (cp_ticket_type_cd === 'O') return '[OT]';
            else if (cp_ticket_type_cd === 'S') return '[운동복]';

            return '';
        },

        // 엑셀에서 이용권 현황을 위한 문자열 생성
        ticketCntStringExcel(cc_less_join_cnt, cc_less_absn_cnt, cc_less_cnt) {
            cc_less_join_cnt = cc_less_join_cnt != null ? cc_less_join_cnt : 0;
            cc_less_absn_cnt = cc_less_absn_cnt != null ? cc_less_absn_cnt : 0;

            const cc_less_used_cnt = cc_less_join_cnt + cc_less_absn_cnt;

            return `${cc_less_used_cnt}/${cc_less_cnt}회(출석 ${cc_less_join_cnt} / 결석 ${cc_less_absn_cnt})`;
        },

        // 엑셀에서 결제 정보를 위한 문자열 생성
        paymentInfoStringExcel(cc_bill_info, cc_total_debt_price) {
            let paymentInfo = this.convertBill(cc_bill_info);

            if (cc_total_debt_price !== 0) {
                paymentInfo += `, [미수금]${numberFormat(cc_total_debt_price)}원`;
            }

            return paymentInfo;
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
    },
};
</script>
<style lang="scss"></style>
